module.exports = __webpack_public_path__ + "static/img/IMG_0445.555ab1e7.jpg";